module.exports = __webpack_public_path__ + "static/media/dropdown-dots.120d6117.svg";